import {
  TTQ_NUMBER_NODE_H,
  TTQ_NUMBER_NODE_W,
} from './ttqibConvergeLodLayout';

type TtqNumberNodeProps = {
  particleId: string;
  x: number;
  y: number;
  width?: number;
  height?: number;
  label: string;
  selected?: boolean;
  memberLinked?: boolean;
  pickMode?: boolean;
  derived?: boolean;
  title?: string;
  onPointerDown?: (particleId: string, clientX: number, clientY: number, pointerId: number) => void;
  onActivate?: (particleId: string) => void;
  onHoverStart?: (particleId: string) => void;
  onHoverEnd?: (particleId: string, relatedTarget: EventTarget | null) => void;
};

/**
 * 双状态 LOD 共用的简单标号节点（多对一关系层显示衍生/原始）。
 */
export function TtqNumberNode({
  particleId,
  x,
  y,
  width = TTQ_NUMBER_NODE_W,
  height = TTQ_NUMBER_NODE_H,
  label,
  selected = false,
  memberLinked = false,
  pickMode = false,
  derived = false,
  title,
  onPointerDown,
  onActivate,
  onHoverStart,
  onHoverEnd,
}: TtqNumberNodeProps) {
  return (
    <button
      type="button"
      data-ttq-particle={particleId}
      data-ttq-number-node=""
      data-particle-id={particleId}
      title={title || label}
      aria-label={`知识颗粒 ${label}`}
      aria-pressed={selected || memberLinked}
      className={
        'absolute flex select-none items-center justify-center overflow-hidden rounded-2xl border-2 font-black tabular-nums shadow-md transition-colors '
        + (pickMode ? 'z-30 ' : 'z-20 ')
        + (pickMode
          ? (memberLinked
            ? 'cursor-not-allowed border-indigo-300 bg-indigo-50/70 text-indigo-700/70 opacity-70 '
            : 'cursor-copy border-teal-600 bg-teal-100 text-teal-950 ring-2 ring-teal-500/60 ')
          : '')
        + (selected
          ? 'border-primary bg-primary/15 text-primary'
          : memberLinked
            ? 'border-indigo-500 bg-indigo-50 text-indigo-800 ring-2 ring-indigo-400/40'
            : derived
              ? 'border-teal-600/50 bg-teal-50 text-teal-900'
              : 'border-stone-500 bg-white text-stone-800')
      }
      style={{
        left: x,
        top: y,
        width,
        height,
        fontSize: Math.max(40, Math.min(72, height * 0.44)),
      }}
      onPointerDown={(event) => {
        if (event.button !== 0 && event.button !== 1) return;
        event.stopPropagation();
        // 与 TtqParticleCard 一致：在 pointerdown 就激活选中。
        // beginPan 会把 pointer capture 到画布容器，导致后续 click 到不了本按钮。
        onActivate?.(particleId);
        onPointerDown?.(particleId, event.clientX, event.clientY, event.pointerId);
      }}
      onClick={(event) => {
        // 选择已在 pointerdown 完成；此处仅阻断冒泡，避免空白点击清选/收浮窗。
        event.stopPropagation();
        event.preventDefault();
      }}
      onMouseEnter={() => onHoverStart?.(particleId)}
      onMouseLeave={(event) => onHoverEnd?.(particleId, event.relatedTarget)}
    >
      {label}
    </button>
  );
}
